import { useMemo } from 'react';

import { useT } from '../../../i18n';
import type { KhoaDich } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { tachThoiLuong, tomTatDieuKien } from '../nghiep-vu/quy-tac-canh-bao';
import type { LoiQuyTac, PhanDieuKien } from '../nghiep-vu/quy-tac-canh-bao';
import type { QuyTacCanhBao } from '../types';

/** Chữ của quy tắc: điều kiện, ngưỡng, thời lượng, lỗi — dùng chung cho bảng và ngăn sửa. */
export function useChuQuyTac() {
  const { t, locale } = useT();
  return useMemo(() => {
    const thoiLuong = (giay: number) => {
      const { so, donVi } = tachThoiLuong(giay);
      return t(`quyTacCanhBao.thoiLuong.${donVi}` as KhoaDich, { so: soVN(so, locale) });
    };
    const phan = (p: PhanDieuKien): string => {
      switch (p.loai) {
        case 'quyet_dinh':
          return t(`quyTacCanhBao.quyetDinh.${p.giaTri}` as KhoaDich);
        case 'action':
          return t('quyTacCanhBao.tomTat.action', { ds: p.ds.join(', ') });
        case 'resource':
          return t('quyTacCanhBao.tomTat.resource', { tienTo: p.tienTo });
        case 'nguon':
          return t('quyTacCanhBao.tomTat.nguon', {
            ds: p.ds.map((n) => t(`quyTacCanhBao.nguon.${n}` as KhoaDich)).join(', '),
          });
        case 'ma_loi':
          return t('quyTacCanhBao.tomTat.maLoi', { ds: p.ds.join(', ') });
        case 'moi_su_kien':
          return t('quyTacCanhBao.tomTat.moiSuKien');
      }
    };
    return {
      thoiLuong,
      dieuKien: (q: QuyTacCanhBao) => tomTatDieuKien(q).map(phan).join(' · '),
      nguong: (q: QuyTacCanhBao) =>
        t('quyTacCanhBao.nguongTomTat', {
          so: soVN(q.threshold, locale),
          cuaSo: thoiLuong(q.window_seconds),
          nhom: t(`quyTacCanhBao.nhomTheo.${q.group_by}` as KhoaDich),
        }),
      loi: (l: LoiQuyTac) => {
        const p = l.thamSo ?? {};
        return t(`quyTacCanhBao.loi.${l.ma}` as KhoaDich, {
          ...p,
          ...(typeof p.min === 'number' ? { min: soVN(p.min, locale) } : {}),
          ...(typeof p.max === 'number' ? { max: soVN(p.max, locale) } : {}),
        });
      },
      tenTruong: (truong: string) => t(`quyTacCanhBao.truong.${truong}` as KhoaDich),
    };
  }, [t, locale]);
}
